import { AppBar, Box, Button, Dialog, DialogActions, Toolbar, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useImageSetCover } from '../../../../../../../effects/image/image';
import Transition from '../../../../../../../lib/dialogTransition';
import { ICoverDialogProps } from './interfaces';

const i18_PATH = 'prodotto.view.lottoImages.dialog.coverDialog.'

function CoverDialog({ isOpen, image, close }: ICoverDialogProps) {
	const { t } = useTranslation();
	const [id, setId] = useState<number | null>(null);
	const onSubmit = () => {
		if (!!image) setId(image.id);
	}
	useEffect(() => {
		setId(null);
	}, [image])
	useImageSetCover(id);
	return (
		<Dialog
			open={isOpen}
			onClose={close}
			TransitionComponent={Transition}
			fullWidth
			maxWidth="md"
		>
			<AppBar sx={{ position: 'relative' }}>
				<Toolbar variant="dense">
					<Typography variant="h5" sx={{ flex: 1 }} display="block" >{t(`${i18_PATH}Imposta questa immagine come copertina`)}</Typography>
				</Toolbar>
			</AppBar>
			<Box sx={{ p: 2, overflowY: 'auto' }}>
				<Typography variant="h5" sx={{ flex: 1 }} display="block" >{t(`${i18_PATH}Questa immagine sarà impostata come immagine principale del lotto, continuare?`)}</Typography>
			</Box>
			<DialogActions>
				<Button onClick={close}>{t(`${i18_PATH}Cancella`)}</Button>
				<Button onClick={onSubmit} variant="contained" color="primary">{t(`${i18_PATH}Salva`)}</Button>
			</DialogActions>
		</Dialog >
	);
}

export default CoverDialog;